import { ACTIONS } from './constants';

const initialState = {
	activePaymentMethod: '',
	longId: null,
	env: null,
	sdkState: 'UNINITIALIZED',
	forceHostedFlow: true,
	isValid: false,
	availableDropInComponents: []
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case ACTIONS.SET_EXTENSION_DATA:
			return { ...state, extension: action.payload };
		case ACTIONS.SET_LONG_ID:
			return { ...state, longId: action.payload };
		case ACTIONS.SET_LIST_URL:
			return { ...state, listUrl: action.payload };
		case ACTIONS.SET_ENV:
			return { ...state, env: action.payload };
		case ACTIONS.SET_SDK:
			return { ...state, sdk: action.payload };
		case ACTIONS.SET_SDK_STATE:
			return { ...state, sdkState: action.payload };
		case ACTIONS.SET_ACTIVE_PAYMENT_METHOD:
			return { ...state, activePaymentMethod: action.payload };
		case ACTIONS.SET_FORCE_HOSTED_FLOW:
			return { ...state, forceHostedFlow: action.payload };
		case ACTIONS.SET_IS_VALID:
			return { ...state, isValid: action.payload };
		case ACTIONS.ADD_COMPONENT:
			return {
				...state,
				availableDropInComponents: {
					...state.availableDropInComponents,
					[action.payload.name]: action.payload.component
				}
			};
		case ACTIONS.REMOVE_COMPONENT:
			let availableDropInComponents = { ...state.availableDropInComponents };
			delete availableDropInComponents[action.payload.name];
			return { ...state, availableDropInComponents };
		default:
			return state;
	}
};

export default reducer;
